<template>
  <div class="stock">
    <stock-header />
    <stock-body />
  </div>
</template>

<script>
import Header from "../components/stock/Header";
import Body from "../components/stock/Body";

export default {
  components: {
    "stock-header": Header,
    "stock-body": Body
  }
};
</script>

<style scoped></style>
